import { Grid } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';

import { SearchContextProvider } from './context/search-context';

import { GridRightPanel } from './search-grid-right-panel';
import SearchV3 from './v3';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleWrapper: {
      backgroundColor: '#626262',
      color: 'white',
      flexShrink: 0,
      padding: 25,
    },

    gridLeftPanel: {
      overflow: 'auto',
      position: 'sticky',
      top: 80,
      height: 'calc(100vh - 80px)',
      fontSize: 12,
      lineHeight: 1.8,
      backgroundColor: theme.palette.secondary.main,
      boxShadow: theme.shadows[1],
      fontWeight: 'normal',
    },
    body: {},
    table: {
      margin: '25px 0',
    },
    tableContainer: {
      maxHeight: 'none',
    },
    resultContainer: {
      padding: '1rem 0',
    },
    noResults: {
      padding: '2rem 0',
    },
    rightPanel: {
      backgroundColor: 'blue',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  })
);

export function Search() {
  const classes = useStyles();
  return (
    <SearchContextProvider>
      <Grid container>
        <Grid item xs={12} md={12} lg={12} className={classes.body}>
          <Grid container>
            <Grid item md={12} lg={10}>
              <SearchV3 />
            </Grid>
            <Grid item md={1} lg={2} className={classes.rightPanel}>
              <GridRightPanel />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SearchContextProvider>
  );
}
